import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    profile: null,
    lagiNgerjain: localStorage.lagiNgerjain,
    lagiNgerjainHalaman: localStorage.lagiNgerjainHalaman,
    waktuMulai: localStorage.waktuMulai,
    jawaban: localStorage.jawaban
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setProfile(state, profile) {
      state.profile = profile
    },
    setLagiNgerjain(state, payload) {
      state.lagiNgerjain = payload.lagiNgerjain
      state.lagiNgerjainHalaman = payload.lagiNgerjainHalaman

      localStorage.lagiNgerjain = payload.lagiNgerjain
      localStorage.lagiNgerjainHalaman = payload.lagiNgerjainHalaman

      if (payload.lagiNgerjain == true || payload.lagiNgerjain == 'true') {
        const date = new Date()
        state.waktuMulai = date
        localStorage.waktuMulai = date
      }
    },
    updateJawaban(state, jawaban) {
      state.jawaban = jawaban
      
      localStorage.jawaban = jawaban
    }
  },
  actions: {
  },
  modules: {
  }
})
